export const GET_FILEBLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    fileBlock(id: "${id}", preview: ${preview}) {
    sys {
        id
      }
      imageVaultFile
      metaData
      ivThumbnail
      indexFile
      relatedInfoLink {
        linkText
        globalLinkItem
        reference {
          ...on Page {
            content {
              __typename
            }
            slug
          }
          ...on FileBlock
          {
            imageVaultFile
          }
        }
        url
        newTab
        ikon
    }
      audienceCollection{
      items{
          __typename
          sys{id}
          audianceId
        }
      }
    }
  }
`;
